module.exports = __webpack_public_path__ + "img/DE01840.98d1eae2.png";